import { ErrorHelperText } from '@components/ErrorHelperText';
import { Label } from '@components/Label';
import { TextArea } from '@components/TextArea';
import { FormControlLabel, FormHelperText, Stack, SxProps } from '@mui/material';
import { buildDataTestId, buildDataTestIdAttribute, replaceCebabCase } from '@src/utils';
import { ChangeEvent, FC } from 'react';
import { Controller, get } from 'react-hook-form';

type TextAreaProps = {
  name: string;
  label: string;
  required?: boolean;
  control?: any;
  onChange?: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  placeholder?: string;
  maxLength?: number;
  disabled?: boolean;
  sx?: SxProps;
  dataTestId?: string;
};
export const FormTextAreaField: FC<TextAreaProps> = ({
  name,
  label,
  control,
  required,
  sx,
  maxLength = 1000,
  placeholder = 'Your message',
  disabled = false,
  dataTestId,
}) => {
  const inputDataTestId = buildDataTestId(dataTestId, `input-${replaceCebabCase(name)}`);
  return (
    <FormControlLabel
      label={<Label label={label} required={required} disabled={disabled} />}
      sx={{ width: '100%', ...sx }}
      labelPlacement="top"
      control={
        <Controller
          name={name}
          control={control}
          render={({ field: { ref, ...field }, formState }) => {
            const errorField = get(formState.errors, name);
            const error = errorField && (errorField.message as string);
            return (
              <>
                <Stack direction="row" justifyContent="flex-end" width="100%">
                  <FormHelperText
                    sx={{
                      order: '-1',
                      height: 0,
                    }}
                  >
                    {field.value?.length || 0}/{maxLength}
                  </FormHelperText>
                </Stack>
                <TextArea
                  {...field}
                  placeholder={placeholder}
                  rows={5}
                  color="secondary"
                  inputProps={{ maxLength, ...buildDataTestIdAttribute(inputDataTestId) }}
                  disabled={disabled}
                />
                <ErrorHelperText error={error} />
              </>
            );
          }}
        />
      }
    />
  );
};
